import React, { useState, useEffect } from "react";
import { format, differenceInDays } from "date-fns";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { CSVLink } from "react-csv";
import CSVReader from "react-csv-reader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import Lottie from "react-lottie";
import ReactExport from "react-data-export";
import { SubmitLocalStorageSearch } from "../../function";

// COMPONENTS
import LoadingMutation from "../Loading/LoadingMutation";

// REDUX
import { onChangeSearchBar } from "../../_redux/searchBarSlice";

// COMPONENTS
import ContainerContent from "../Container/ContainerContent";
import GiftRequestTable from "../GiftRequest/GiftRequestTable";
import Loading from "../Loading/LoadingPage";
import PrevPage from "../Pagination/PrevPage";
import NumberPage from "../Pagination/NumberPage";
import NextPage from "../Pagination/NextPage";
import SelectRows from "../Pagination/SelectRows";
import DataEmpty from "../DataEmpty";

// AWS
import { S3Image } from "aws-amplify-react";
import { API, Auth, Storage } from "aws-amplify";
import AWS from "aws-sdk";

// HOOKS
import useGiftRequest from "../../hooks/useGiftRequest";
import useGiftRequestCount from "hooks/useGiftRequestCount";

// UTILS
import { getCurrentLocalDateTime } from "../../utils/getLocalDateTime";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const optionsStatus = [
  {
    label: "PENDING",
    value: "PENDING",
  },
  {
    label: "APPROVE",
    value: "APPROVE",
  },
  {
    label: "REJECT",
    value: "REJECT",
  },
];

const optionsLimit = [
  {
    label: 50,
    value: 50,
  },
  { label: 100, value: 100 },
  { label: 150, value: 150 },
  { label: 200, value: 200 },
  { label: 250, value: 250 },
  { label: 300, value: 300 },
  { label: 350, value: 350 },
  { label: 400, value: 400 },
  { label: 450, value: 450 },
  { label: 500, value: 500 },
  { label: 1000, value: 1000 },
];

function GiftRequestMain() {
  const Limit = 15;
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.initializeApp);
  const searchBar = useSelector((state) => state.searchBar);

  const DEFAULT_QUERY = {
    Limit,
    order_status: "PENDING",
    countData: 1,
    min: "",
    max: getCurrentLocalDateTime().fullDate,
  };

  const { datas, loading, error, getData, count, setDatas } =
    useGiftRequest(DEFAULT_QUERY);
  const {
    datas: datasCount,
    loading: loadingCount,
    error: errorCount,
    getData: getDataCount,
  } = useGiftRequestCount(DEFAULT_QUERY);

  const [searchBy, setSearchBy] = useState("phone_number");

  const [allTime, setAllTime] = useState(true);
  const [min, setMin] = useState("");
  const [max, setMax] = useState(DEFAULT_QUERY.max);
  const [selectStatus, setSelectStatus] = useState(optionsStatus[0]);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState({ value: Limit, label: Limit });
  const [dataExport, setDataExport] = useState([]);
  const [pageType, setPageType] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [firstLanding, setFirstLanding] = useState(true);
  const [loadingExport, setLoadingExport] = useState(false);
  const [loadingImport, setLoadingImport] = useState(false);
  const [query, setQuery] = useState(DEFAULT_QUERY);

  if (loading) {
    return (
      <ContainerContent>
        <Loading />
      </ContainerContent>
    );
  }
  if (error) {
    return <p>Error...</p>;
  }

  const importOptions = {
    header: true,
    dynamicTyping: true,
    skipEmptyLines: true,
  };

  const onSelect = (name) => (e) => {
    const { value } = e;
    setQuery((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const onField = (e) => {
    const { name, value } = e.target;
    setQuery((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const onClickExportExcel = async () => {
    setLoadingExport(true);
    const data = await API.get("MoneyHubAdmin", "/exportExcel", {
      queryStringParameters: {
        TableName: "loan_request",
      },
      headers: {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    });

    const parseData = JSON.parse(data.body);
    setDataExport(
      parseData.Items.filter((item) =>
        ["ยืนยัน", "สมบูรณ์"].includes(item.loan_status)
      )
    );
    toast.success("ข้อมูลของคุณพร้อมแล้ว!");
    setLoadingExport(false);
  };

  const onClickResetFilter = async () => {
    setQuery(DEFAULT_QUERY);
    dispatch(onChangeSearchBar(""));
    setSearchBy("phone_number");
    setPageIndex(0);
    setPageType(null);
    await getData(DEFAULT_QUERY);
    await getDataCount(DEFAULT_QUERY);
  };

  const getExclusiveStartKey = (index) => {
    if (query.order_no) {
      return `order_id=${datas[index].order_id}&order_no=${datas[index].order_no}`;
    } else if (query.status === "All") {
      return `isCreated=true&order_id=${datas[index].order_id}`;
    } else if (query.reciever) {
      return `order_id=${datas[index].order_id}&timestamp=${datas[index].timestamp}&reciever=${datas[index].reciever}`;
    } else if (query.item_name) {
      return `order_id=${datas[index].order_id}&timestamp=${datas[index].timestamp}&item_name=${datas[index].item_name}`;
    } else if (query.phone_number) {
      return `order_id=${datas[index].order_id}&timestamp=${datas[index].timestamp}phone_number=${datas[index].phone_number}`;
    }
    return `order_status=${datas[index].order_status}&order_id=${datas[index].order_id}`;
  };

  const onChangeLimit = async (e) => {
    setPageSize(e);
    setPageIndex(0);
    let newQuery = {
      ...query,
      Limit: e.value,
    };
    delete newQuery?.ExclusiveStartKey;
    setQuery(newQuery);
    await getData(newQuery);
  };

  const onClickPrevPage = async () => {
    let newQuery = {
      ...query,
      Limit: +pageSize.value,
      countData: 1,
      ScanIndexForward: true,
    };
    if (pageType === "NEXT" && !datas.length) {
      newQuery = {
        ...newQuery,
      };
    } else {
      newQuery = {
        ...newQuery,
        ExclusiveStartKey: getExclusiveStartKey(0),
      };
    }
    setPageIndex((prev) => prev - 1);
    setPageType("PREV");
    await getData(newQuery, { sortBy: true, isLoading: true });
  };

  const onClickNextPage = async () => {
    const lastIndex = datas.length - 1;
    const newQuery = {
      ...query,
      countData: 1,
      ScanIndexForward: false,
      Limit: +pageSize.value,
      ExclusiveStartKey: getExclusiveStartKey(lastIndex),
    };
    setPageIndex((prev) => prev + 1);
    setPageType("NEXT");
    await getData(newQuery, { isLoading: true });
  };

  const getOption = (options, value) => {
    const findIndex = options.findIndex((option) => option.value === value);
    return options[findIndex];
  };

  const onComplete = async (e) => {
    for (const row of selectedRows) {
      const { order_no, phone_number, order_status, points, tracking_id } =
        row.original;
      let title =
        order_status === "APPROVE"
          ? `คุณยืนยันที่จะอนุมัตินี้หรือไม่ ?`
          : "คุณยืนยันที่จะปฎิเสธคำขอนี้หรือไม่ ?";
      const result = await Swal.fire({
        title,
        showCancelButton: true,
        confirmButtonText: `บันทึก`,
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        showLoaderOnDeny: false,
        preConfirm: async () => {
          await API.put("MoneyHubAdmin", `/giftRequest/${order_no}`, {
            body: {
              order_status: "APPROVE",
              phone_number,
              points,
              tracking_id,
              adminName: user.username,
            },
            headers: {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            },
          });
        },
      });
      if (!result.isConfirmed) return;
      await Swal.fire({
        title: "SUCCESS",
        text: "สร้างสินค้าสำเร็จ",
        icon: "success",
        confirmButtonText: "ยืนยัน",
      });
      await getData(query);
    }
    try {
    } catch (error) {
      console.log("Error", error);
      await Swal.fire({
        title: "ERROR",
        text: "Something went wrong",
        icon: "error",
        confirmButtonText: "ยืนยัน",
      });
    }
  };

  const onImportExcel = async (importDatas, fileInfo) => {
    try {
      setLoadingImport(true);
      let newDatas = [...datas];
      for (const importData of importDatas) {
        await API.put("MoneyHubAdmin", `/giftRequest/tracking`, {
          body: {
            order_no: importData.order_id,
            tracking_id: importData.tracking_id,
            adminName: user.username,
            reciever: importData.name,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
      }
      await getData(query);
      toast.success("ซิงค์ข้อมูล CSV สมบูรณ์");
    } catch (error) {
      console.log("ERROR", error);
      await Swal.fire({
        title: "ERROR",
        text: "Something went wrong",
        icon: "error",
        confirmButtonText: "ยืนยัน",
      });
    } finally {
      setLoadingImport(false);
    }
  };

  const onSubmitFilter = async () => {
    SubmitLocalStorageSearch(searchBar);
    setPageIndex(0);
    setPageType(null);
    let newQuery = {
      ...query,
    };
    if (searchBar.value) {
      newQuery = {
        ...query,
        [searchBy]: searchBar.value,
      };
    } else {
      delete newQuery?.request_id;
      delete newQuery?.name;
      delete newQuery?.adminName;
      delete newQuery?.requestamount;
      delete newQuery?.phone_number;
    }
    delete newQuery?.ExclusiveStartKey;
    setQuery(newQuery);
    await getData(newQuery);
    await getDataCount(newQuery);
  };

  const headers = [
    { label: "order_no", key: "order_no" },
    { label: "tracking_id", key: "tracking_id" },
    { label: "reciever", key: "reciever" },
    { label: "phone_number", key: "phone_number" },
    { label: "item_name", key: "item_name" },
    { label: "points", key: "points" },
    { label: "unit", key: "Unit" },
    { label: "timestamp", key: "timestamp" },
    { label: "order_status", key: "order_status" },
  ];

  const dataCsv = selectedRows?.map((row) => {
    const { original } = row;
    return {
      order_no: original.order_id,
      tracking_id: original.tracking_id,
      receiver: original.receiver,
      phone_number: original.phone_number,
      item_name: original.item_name,
      points: original.points,
      unit: original.unit,
      timestamp: original.timestamp
        ? format(new Date(original.timestamp), "dd-MM-yyyy")
        : "",
      order_status: original.order_status,
    };
  });

  const refresh = async () => {
    let newQuery = {
      ...query,
    };
    await getData(newQuery);
    // await getDataCount(newQuery);
  };

  const createDataWithStyle = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    const style = {
      font: { sz: 14 },
      alignment: { vertical: "center", horizontal: "center" },
      // border: borders,
    };

    for (let i = 0; i < data.length; i++) {
      result.push([
        {
          value: data[i].original.order_id,
          style,
        },
        {
          value: data[i].original.tracking_id || "-",
          style,
        },
        {
          value: data[i].original.reciever || "-",
          style,
        },
        {
          value: data[i].original.phone_number,
          style,
        },
        {
          value: data[i].original.item_name,
          style,
        },
        {
          value: data[i].original.points,
          style,
        },
        {
          value: data[i].original.unit,
          style,
        },
        {
          value: format(new Date(data[i].original.timestamp), "dd-MM-yyyy"),
          style,
        },
        {
          value: data[i].original.order_status,
          style,
        },
        {
          value: data[i].original.address || "",
          style,
        },
      ]);
    }
    return result;
  };

  const style = {
    font: { sz: 16, name: "Cordia New" },
    alignment: { vertical: "center", horizontal: "center" },
    // borders: {
    //   top: { style: "thin" },
    //   bottom: { style: "thin" },
    //   left: { style: "thin" },
    //   right: { style: "thin" },
    // },
  };

  const onClickExport = () => {
    const exportClick = document.getElementById("loan");
    exportClick.click();
  };

  const multiDataSet = [
    {
      columns: [
        {
          title: "Order no",
          width: { wch: 46 },
          style,
        }, //pixels width
        {
          title: "เลขที่ติดตาม",
          width: { wch: 38 },
          style,
        }, //pixels width
        {
          title: "ชื่อผู้รับ",
          width: { wch: 24 },
          style,
        }, //char width
        {
          title: "เบอร์โทร",
          width: { wch: 24 },
          style,
        },
        {
          title: "สินค้า",
          width: { wch: 24 },
          style,
        },
        {
          title: "Points",
          width: { wch: 24 },
          style,
        },
        {
          title: "Unit",
          width: { wch: 24 },
          style,
        },
        {
          title: "วันที่สร้าง",
          width: { wch: 24 },
          style,
        },
        {
          title: "สถานะ",
          width: { wch: 36 },
          style,
        },
        {
          title: "ที่อยู่",
          width: { wch: 100 },
          style,
        },
      ],
      data: createDataWithStyle(selectedRows),
    },
  ];

  return (
    <ContainerContent>
      <div className="mx-4 w-full mb-2 lg:flex flex-col">
        {loadingImport && (
          <div className="fixed z-10 inset-0 overflow-y-auto bg-black bg-opacity-70 backdrop-filter backdrop-blur-sm flex justify-center items-center    ">
            <div className="w-2/5 h-auto mx-auto  ">
              <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: Loading,
                  isStopped: false,
                  isPaused: false,
                  rendererSettings: {
                    preserveAspectRatio: "xMidYMid slice",
                  },
                }}
              />
              <div className="text-center text-white text-xl">
                กำลัง Sync ข้อมูล CSV กับ Transactions{" "}
              </div>
            </div>
          </div>
        )}
        <div className="">
          ค้นหาโดยใช้&nbsp;
          <label class="inline-flex items-center lg:ml-2">
            <input
              onChange={(e) => setSearchBy("order_no")}
              type="radio"
              class="form-radio"
              name="search"
              defaultChecked={true}
              checked={searchBy === "order_no"}
            />
            <span class="ml-2">Order No</span>
          </label>
          <label class="inline-flex items-center ml-2">
            <input
              onChange={(e) => setSearchBy("reciever")}
              type="radio"
              class="form-radio"
              name="search"
              checked={searchBy === "reciever"}
            />
            <span class="ml-2">ชื่อ - นามสกุล</span>
          </label>
          <label class="inline-flex items-center ml-2">
            <input
              onChange={(e) => setSearchBy("adminName")}
              type="radio"
              class="form-radio"
              name="search"
              checked={searchBy === "adminName"}
            />
            <span class="ml-2">ชื่อแอดมิน</span>
          </label>
          <label class="inline-flex items-center ml-2">
            <input
              onChange={(e) => setSearchBy("phone_number")}
              type="radio"
              class="form-radio"
              name="search"
              checked={searchBy === "phone_number"}
            />
            <span class="ml-2">เบอร์โทร</span>
          </label>
          <label class="inline-flex items-center ml-2">
            <input
              onChange={(e) => setSearchBy("item_name")}
              type="radio"
              class="form-radio"
              name="search"
              checked={searchBy === "item_name"}
            />
            <span class="ml-2">ชื่อสินค้า</span>
          </label>
        </div>
        <div className="flex items-center mt-4">
          {/* {user?.groups?.some((group) => ["SuperAdmin"].includes(group)) && (
            <button
              disabled={!selectedRows.length}
              className={classNames(
                " border p-1 px-2 rounded  duration-300 hover:text-white",
                {
                  "bg-gray-300 cursor-not-allowed text-white":
                    !selectedRows.length,
                  "border-green-500 p-1 px-2 rounded text-green-500 hover:bg-green-600 hover:text-white":
                    selectedRows.length,
                }
              )}
              onClick={onComplete}
            >
              Complete All
            </button>
          )} */}
          {/* <button
            disabled={loadingExport}
            onClick={onClickExportExcel}
            className={classNames("ml-2     ", {
              " text-gray-500": loadingExport,
              "border   duration-300  border-green-500 p-1 px-2 rounded text-green-500 hover:bg-green-600 hover:text-white":
                !loadingExport,
            })}
          >
            {loadingExport ? <LoadingMutation /> : "Fetch Data"}
          </button> */}
          <ToastContainer
            position="top-center"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          <ExcelFile
            filename={`GIFT_REQUEST${format(new Date(), "yyyy-MM-dd")}`}
            element={<button id="loan" hidden></button>}
          >
            <ExcelSheet dataSet={multiDataSet} name="GIFT_REQUEST"></ExcelSheet>
          </ExcelFile>
          <button
            disabled={!selectedRows.length}
            className={classNames(
              "ml-2 border p-1 px-2 rounded  duration-300 hover:text-white",
              {
                "bg-gray-300 cursor-not-allowed text-white":
                  !selectedRows.length,
                "border-green-500 p-1 px-2 rounded text-white hover:bg-green-600 bg-green-500  hover:text-white":
                  selectedRows.length,
              }
            )}
            onClick={onClickExport}
          >
            Export Excel
          </button>
          {/* <CSVLink
            disabled={!selectedRows.length}
            headers={headers}
            data={dataCsv}
            filename={`GIFT_REQUEST${format(new Date(), "dd-MM-yyyy")}.xls`}
          >
            <button
              className={classNames(
                "ml-2 border p-1 px-2 rounded  duration-300 hover:text-white",
                {
                  "bg-gray-300 cursor-not-allowed text-white":
                    !selectedRows.length,
                  "border-green-500 p-1 px-2 rounded text-white hover:bg-green-600 bg-green-500  hover:text-white":
                    selectedRows.length,
                }
              )}
            >
              Export Excel
            </button>
          </CSVLink> */}
          <div className="ml-2">
            <CSVReader
              parserOptions={importOptions}
              onFileLoaded={onImportExcel}
            />
          </div>
        </div>
      </div>
      <div className="flex mb-4 ml-4">
        <div className="lg:flex items-center ">
          <div className="lg:mr-2">Request Period</div>
          <input
            name="min"
            value={query.min}
            onChange={onField}
            type="date"
            className="p-2 py-1 border rounded shadow-sm"
          />
        </div>
        <div className="lg:flex items-center lg:ml-4">
          <div className="lg:mr-2">To</div>
          <input
            name="max"
            value={query.max}
            onChange={onField}
            type="date"
            className="p-2 py-1 border rounded shadow-sm mr-2"
          />
        </div>
        <div className="my-1 lg:my-0 lg:ml-4 w-52">
          <Select
            defaultValue={optionsStatus[0]}
            value={getOption(optionsStatus, query.order_status)}
            options={optionsStatus}
            onChange={onSelect("order_status")}
          />
        </div>
        <button
          className="ml-2 border border-blue-500 p-1 px-2 rounded text-blue-500 hover:bg-blue-600 duration-300 hover:text-white"
          onClick={onSubmitFilter}
        >
          Submit
        </button>
        <button
          className="ml-2 p-1 px-2 border border-red-500  rounded text-red-500 hover:bg-red-200 duration-300 hover:text-white"
          onClick={onClickResetFilter}
        >
          Clear
        </button>
        <svg
          onClick={refresh}
          xmlns="http://www.w3.org/2000/svg"
          className="h-9 w-9 rounded border border-gray-500 hover:bg-gray-200 text-gray-700 ml-2 p-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
          />
        </svg>
      </div>
      {!datas.length ? (
        pageType === "NEXT" ? (
          <ContainerContent>
            <div className="text-gray-700 font-bold text-xl w-full text-center mt-20">
              สิ้นสุดรายการ
            </div>
            <div className="w-full mt-2 flex items-center">
              {" "}
              <button
                className="bg-blue-500 text-xl p-4  mx-auto text-white mt-2 "
                onClick={onClickPrevPage}
              >
                ย้อนกลับ
              </button>
            </div>
          </ContainerContent>
        ) : (
          <ContainerContent>
            <DataEmpty />
          </ContainerContent>
        )
      ) : (
        <React.Fragment>
          <div className="flex w-full p-4 pt-0">
            <div className="my-auto w-full">
              {loadingCount ? <div>Loading...</div> : datasCount.length} Records
            </div>
            <div className=" flex justify-between gap-4 ">
              <nav
                className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
                aria-label="Pagination"
              >
                <PrevPage
                  canPreviousPage={pageIndex !== 0}
                  onClick={onClickPrevPage}
                />
                <NumberPage number={pageIndex} pageIndex={pageIndex} />
                <NextPage onClick={onClickNextPage} canNextPage={true} />
              </nav>
              <div className="w-24 flex">
                <SelectRows
                  pageSize={pageSize}
                  onChange={onChangeLimit}
                  options={optionsLimit}
                />
              </div>
            </div>
          </div>
          <GiftRequestTable
            setSelectedRows={setSelectedRows}
            data={datas}
            getData={getData}
            where={query}
          />
        </React.Fragment>
      )}
    </ContainerContent>
  );
}

export default GiftRequestMain;
